/** @class VisuallyHiddenMixin */
/** @method */
export var VisuallyHiddenMixin = function VisuallyHiddenMixin() {
  return "\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n";
};